/** 登录 / 登出后整页刷新，清 keep-alive 与用户态缓存（登出等兜底；登录主路径勿用） */
export function reloadAppAfterAuthChange(redirect) {
  const target = String(redirect ?? '').trim();
  if (target) {
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (target !== current) {
      window.location.assign(target);
      return;
    }
  }
  window.location.reload();
}

/**
 * 登录成功后的软回跳：保留 keep-alive，禁止 location.assign/reload。
 * 已在目标页则不跳；避免用陈旧 `/` 把详情页踢走（回跳写入侧已改为每次打开刷新）。
 * @param {import('vue-router').Router} router
 * @param {string|null|undefined} redirect
 */
export function softNavigateAfterAuth(router, redirect) {
  const target = String(redirect ?? '').trim();
  if (!target || !router) return;
  const currentFull = String(router.currentRoute?.value?.fullPath ?? '').trim();
  const currentLoc =
    typeof window !== 'undefined'
      ? `${window.location.pathname}${window.location.search}${window.location.hash}`
      : '';
  if (target === currentFull || target === currentLoc) return;
  // 登录前就在公开页：回跳若是首页且当前不是首页，说明 pending 陈旧，留在原地
  if (
    (target === '/' || target === '/home') &&
    currentFull &&
    currentFull !== '/' &&
    currentFull !== '/home' &&
    !router.currentRoute?.value?.meta?.requiresAuth
  ) {
    console.info('[auth] skip stale home soft-redirect, stay on', currentFull);
    return;
  }
  router.push(target).catch((err) => {
    console.warn('[auth] soft navigate after login failed', err);
  });
}
